import { useAxios } from "@hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ExamPeriod } from "@types";

export const useEditApplicantMonitor = (examPeriod?: ExamPeriod) => {

    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const editApplicant = async (examPeriod: any) => {
        try {
            const response = await axios.put(`/api/examinstance/monitor/${examPeriod.id}`, examPeriod.state, {headers: {"Content-Type": "application/json"}});
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.editApplicantMonitor"));
        }
    }

    return useMutation({ mutationFn: editApplicant, onSuccess: (_, vars) => { 
        queryClient.setQueryData(["examPeriods", examPeriod!.id, "monitor"], (old: any) => {
            return old.map((item: any) => {
                if (item.id === vars.id) {
                    return {...item, state: vars.state};
                }
                return item;
            });
        });
    }});
}
